import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSearch = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M32 29.538C32 30.872 30.872 32 29.538 32c-.65 0-1.265-.274-1.743-.718l-6.598-6.598c-2.223 1.572-4.924 2.393-7.659 2.393A13.526 13.526 0 0 1 0 13.538 13.526 13.526 0 0 1 13.538 0a13.526 13.526 0 0 1 13.539 13.538c0 2.735-.82 5.436-2.393 7.659l6.598 6.598c.444.444.718 1.094.718 1.743zm-9.846-16c0-4.752-3.863-8.615-8.615-8.615-4.753 0-8.616 3.863-8.616 8.615 0 4.753 3.863 8.616 8.616 8.616 4.752 0 8.615-3.863 8.615-8.616z" /></g></svg>;
export default SvgSearch;